
class CategorySelectionCell extends UITableViewCell
{

}